import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import React from 'react'

// Methods
import { getPurchaseLimitQuantity, getPurchaseLimitRemaining, isPurchaseLimitActive, IPurchaseLimitInfo } from '@/methods/purchaseLimit'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IPurchaseLimitNotice {
  className?: string
  limitInfo?: IPurchaseLimitInfo
  /** 放在商品詳情規格區時開啟，補上標籤欄寬度讓文案對齊數量選擇器等欄位的內容 */
  alignWithSpecLabel?: boolean
}

/** 商品細節頁的限購說明。沒有生效中的限購時不顯示。 */
const PurchaseLimitNotice = (props: IPurchaseLimitNotice) => {
  const { className, limitInfo, alignWithSpecLabel = false } = props
  const { t } = useTranslation()

  if (!isPurchaseLimitActive(limitInfo)) return null

  return (
    <div className={cx('purchase-limit-notice', className)}>
      {alignWithSpecLabel && <span aria-hidden='true' className={cx('purchase-limit-notice__label-offset')} />}
      <span className={cx('purchase-limit-notice__text')}>
        {t('Product_Purchase_Limit_Description', {
          limit: getPurchaseLimitQuantity(limitInfo),
          remaining: getPurchaseLimitRemaining(limitInfo),
        })}
      </span>
    </div>
  )
}

export default PurchaseLimitNotice
